import { HomeLocationQueries } from '@/graphql/homeLocations.queries'
import { useGraphql } from '@/hooks/useGraphql'
import { HomeLocation } from '@/types/HomeLocation'

const useHomeLocations = () => {
  const homeLocationQuery = useGraphql<{ homeLocations: HomeLocation[] }>(
    HomeLocationQueries.QUERY_KEY,
    HomeLocationQueries.getHomeLocations(),
  )
  return homeLocationQuery
}

export default useHomeLocations
